import type { ServicePageConfig } from "../../../types";
import { flytthjalpKungalvPage } from "./kungalv";
import { flytthjalpMolndalPage } from "./molndal";
import { flytthjalpAlingsasPage } from "./alingsas";
import { flytthjalpKungsbackaPage } from "./kungsbacka";
import { flytthjalpSodertaljePage } from "./sodertalje";
import { flytthjalpLidingoPage } from "./lidingo";
import { flytthjalpHuddingePage } from "./huddinge";
import { flytthjalpHaningePage } from "./haninge";
import { flytthjalpVarmdoPage } from "./varmdo";
import { flytthjalpAkersbergaPage } from "./akersberga";
import { flytthjalpUpplandsVasbyPage } from "./upplands-vasby";
import { flytthjalpMarstaPage } from "./marsta";
import { flytthjalpSolnaPage } from "./solna";
import { flytthjalpNackaPage } from "./nacka";
import { flytthjalpTabyPage } from "./taby";
import { flytthjalpSollentunaPage } from "./sollentuna";

export const flytthjalpOrtPages: ServicePageConfig[] = [
  flytthjalpKungalvPage,
  flytthjalpMolndalPage,
  flytthjalpAlingsasPage,
  flytthjalpKungsbackaPage,
  flytthjalpSodertaljePage,
  flytthjalpLidingoPage,
  flytthjalpHuddingePage,
  flytthjalpHaningePage,
  flytthjalpVarmdoPage,
  flytthjalpAkersbergaPage,
  flytthjalpUpplandsVasbyPage,
  flytthjalpMarstaPage,
  flytthjalpSolnaPage,
  flytthjalpNackaPage,
  flytthjalpTabyPage,
  flytthjalpSollentunaPage,
];
